import { useCallback, useEffect } from 'react';
import { createPortal } from 'react-dom';
import styled, { css } from 'styled-components';

export type ModalProps = {
	children?: JSX.Element;
	onCloseModal: () => void;
};

const Modal = ({ children, onCloseModal }: ModalProps) => {
	const handleUserKeyPress = useCallback((e: KeyboardEvent) => {
		if (e.key === 'Escape') {
			onCloseModal();
		}
	}, []);

	useEffect(() => {
		window.addEventListener('keydown', handleUserKeyPress);
		return () => window.removeEventListener('keydown', handleUserKeyPress);
	}, [handleUserKeyPress]);

	return createPortal(<StyledOverlayContainer>{children}</StyledOverlayContainer>, document.body);
};

const StyledOverlayContainer = styled.div(
	({ theme: { zIndex, boxShadow } }) => css`
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: ${boxShadow.modalOverlay};
		opacity: 1;
		z-index: ${zIndex.dropdown};
		-webkit-box-align: center;
		align-items: center;
		inset: 0;
		display: flex;
		-webkit-box-pack: center;
		justify-content: center;
		user-select: none;
	`
);

export default Modal;
